// extracted by mini-css-extract-plugin
export default {"container":"PostViewBanner-module__container--ZLhfb","banner":"PostViewBanner-module__banner--Cw3LH","animatedBackground":"PostViewBanner-module__animatedBackground--cIqIA"};